import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import { dateToPlainFormat } from '@/utils'

export interface ShelfTypeTempChangeCollection {
  collectionId: number
  collectionNo: string
  collectionStatus: SystemCode // 旧配架区分一括変更でのみ使用している
  handlingType: SystemCode
  ndc: string
  book: string
  shelfType: SystemCode
  shelfTypeOld: SystemCode
  revision: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  sortTitle: string
  sortAuthor: string
  displayTitle: string
  displayAuthor: string
  collectionFlag: CollectionFlag
  shelfTypeOldUpdatedDate: string // 旧配架区分一括変更でのみ使用している
}

export function ShelfTypeTempChangeCollectionFromJSON(
  json: any
): ShelfTypeTempChangeCollection {
  return {
    collectionId: exists(json, 'collection_id') ? json.collection_id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    ndc: exists(json, 'ndc') ? json.ndc : '',
    book: exists(json, 'book') ? json.book : '',
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    shelfTypeOld: exists(json, 'shelf_type_old')
      ? SystemCodeFromJSON(json.shelf_type_old)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0,
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    sortAuthor: exists(json, 'sort_author') ? json.sort_author : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    shelfTypeOldUpdatedDate: exists(json, 'shelf_type_old_updated_date')
      ? dateToPlainFormat(json.shelf_type_old_updated_date)
      : ''
  }
}
